<template>
  <QuestionnaireBase :title="title" :form="form" :finishFunction="null">
    <template v-slot:default>
      <component :is="show" :key="1" :ref="show" v-model="form" />
      <component
          v-if="load in $options.components"
          v-show="false"
          :is="load"
          key="load"
          :ref="load"
          v-model="form"
      />
    </template>
  </QuestionnaireBase>
</template>

<script>
import { loadHelpers } from "../loadHelpers";

import QuestionnaireBase from "../../../components/common/questionnaires/questionnaire";
import General from "../../../components/common/questionnaires/fieldsets/mortgage/survey/General";

export default {
  name: "MortgageSurvey",
  mixins: [loadHelpers],
  components: {
    QuestionnaireBase,
    General,
  },
  data() {
    return {
      name: 'Mortgage',
      title: "Mortgage Details",
      url: 'mortgage_survey',
      order: [ // imported components required here to load
          'General',
      ],
            expiryAccessCodeOnFinish: true

    };
  },
};
</script>
